export const BASE_PATH = `/.proxy`
